export default function makeQuery(query) {
  const esc = encodeURIComponent;
  let resp = "?"
  resp += query.filtros.map((item, index) => {
    return Object.keys(item).map(key => `filtros[${index}]` + `[${esc(key)}]` + "=" + item[key]).join("&")
  }).join("&")
  if (query['limite']) {
    resp += `&limite=${query['limite']}`
  }
  if (query['offset']) {
    resp += `&offset=${query['offset']}`
  }
  return resp
}

const operatorMap = {
  CONTAINS: 'contains',
  '=': 'eq',
  '<': 'lt',
  '>': 'gt',
  '<=': 'lte',
  '>=': 'gte'
}
export class QueryMaker {
  constructor(version) {
    this.version = version
    this.filters = []
    this.limitInt = undefined
    this.offsetInt = undefined
    this.orderObj = undefined
  }


  eq(field, value) {
    this._addFilter(field, this.version === 1 ? "=" : "eq", value)
    return this
  }

  not(field, value) {
    this._addFilter(field, this.version === 1 ? "<>" : "not", value)
    return this
  }

  gt(field, value) {
    this._addFilter(field, this.version === 1 ? ">" : "gt", value)
    return this
  }

  gte(field, value) {
    this._addFilter(field, this.version === 1 ? ">=" : "gte", value)
    return this
  }

  lt(field, value) {
    this._addFilter(field, this.version === 1 ? "<" : "lt", value)
    return this
  }

  lte(field, value) {
    this._addFilter(field, this.version === 1 ? "<=" : "lte", value)
    return this
  }

  contains(field, value) {
    this._addFilter(field, this.version === 1 ? "CONTAINS" : "contains", value)
    return this
  }

  limit(limit) {
    this.limitInt = limit
    return this
  }

  offset(offset) {
    this.offsetInt = offset
    return this
  }

  order(order) {
    this.orderObj = order
    return this
  }

  toString() {
    return this.version === 1 ? this._toStringV1() : this._toStringV2()
  }

  _toStringV1() {
    let q = []
    this.filters.forEach((f, i) => q.push(`filtros[${i}][field]=${f.field}&filtros[${i}][operator]=${f.operator}&filtros[${i}][value]=${f.value}`))
    if (this.limitInt) {
      q.push(`limit=${this.limitInt}`)
    }
    if (this.offsetInt) {
      q.push(`&offset=${this.offsetInt}`)
    }
    if (this.orderObj) {
      q.push(`orden=${this.orderObj.type}&ordenar_por=${this.orderObj.field}`)
    }
    return "?" + q.join('&')
  }

  _toStringV2() {
    let query = []
    this.filters.forEach(filter => {
      if (filter.value !== undefined) {
        let operator = operatorMap[filter.operator] || filter.operator
        query.push(`${filter.field}[${operator}]=${filter.value}`)
      }

    })
    if (this.limitInt) {
      query.push(`limit=${this.limitInt}`)
    }
    if (this.offsetInt) {
      query.push(`&offset=${this.offsetInt}`)
    }
    if (this.orderObj) {
      query.push(`order[${this.orderObj.type}]=${this.orderObj.field}`)
    }

    return "?" + query.join('&')
  }

  _addFilter(field, operator, value) {
    this.filters.push({
      field, operator, value
    })
  }
}

const grupos = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F'
]


const redondeo = function calcularRedondeo(numero) {
  const number = parseInt(numero)
  // if (number < 10000) return (Math.ceil(number / 100)) * 100
  const preffix = numero.substr(0, numero.length - 3)
  const suffix = parseInt(numero.substr(-3), 10)
  if (suffix === 0) return parseInt(preffix + "000")
  if (suffix === 500 || (suffix > 0 && suffix <= 499)) return parseInt(preffix + "500")
  if (suffix === 900 || (suffix >= 501 && suffix <= 899)) return parseInt(preffix + "900")
  if (suffix > 901 && suffix <= 999) return parseInt(preffix + "000") + 1000
}

const makeQueryElastic = (filtro) => {
  const fecha = []
  if (filtro.anio) {
    fecha.push(filtro.anio)
  }
  if (filtro.mes) {
    fecha.push(filtro.mes)
  }
  const filtros = {
    filtros: [{value: filtro.productoId, operator: "=", field: "producto.id"}]
  }
  if (fecha.length > 0) {
    const value = fecha.join("-")
    filtros.filtros.push({value, operator: "CONTAINS", field: "created_at.date"})
  }
  console.log(filtros)
  return makeQuery({
    ...filtros
  })
}

const makeQueryHistorico = (filtro) => {

  const esc = encodeURIComponent;
  return "?" + Object.keys(filtro).map((key) => `${key}=${esc(filtro[key])}`).join("&")
}

const cleanObj = function (obj) {
  const propNames = Object.getOwnPropertyNames(obj)
  for (let i = 0; i < propNames.length; i++) {
    let propName = propNames[i]
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "" || obj[propName] === "NaN") {
      delete obj[propName]
    }
  }
  return obj
}

const descripcionFormatter = (descripcion, field) => {
  const splitter = descripcion.split(" ")
  return splitter.map(item => {
    if(field) return {field: field, value: item, operator: 'CONTAINS'}
    return {field: 'descripcion', value: item, operator: 'CONTAINS'}
  })
}

export {grupos, redondeo, makeQueryElastic, makeQueryHistorico, cleanObj, descripcionFormatter}
